import { render, staticRenderFns } from "./Tipocliente.vue?vue&type=template&id=13259efe&scoped=true&"
import script from "./Tipocliente.vue?vue&type=script&lang=js&"
export * from "./Tipocliente.vue?vue&type=script&lang=js&"
import style0 from "./Tipocliente.vue?vue&type=style&index=0&id=13259efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13259efe",
  null
  
)

export default component.exports